<template>
    <div>
        <dx-button @click="changePopupVisibility(true)"> Журнал </dx-button>
        <dx-popup
            ref="popupRef"
            :drag-enabled="false"
            height="95%"
            :hide-on-outside-click="true"
            :show-close-button="true"
            :show-title="true"
            :title="props.title"
            :visible="popupVisible"
            @hidden="changePopupVisibility(false)"
            @shown="emit('popupShown')"
        >
            <slot />
        </dx-popup>
    </div>
</template>
<script>
export default {
    name: 'pcaButtonDictionary',
};
</script>

<script setup>
import { onMounted, ref } from 'vue';
import { DxPopup, DxButton } from 'devextreme-vue';

const emit = defineEmits(['popupShown', 'notifyErrorMessage', 'popupHidden']);

const props = defineProps({
    title: {
        type: String,
        default: '',
    },
    callbacks: {
        type: Object,
        default: () => ({
            dotsClick: () => {
                console.log('pcaButtonDictionary, dotsClick');
            },
        }),
    },
});

const popupRef = ref(null);
const popupInstance = ref(null);

onMounted(() => {
    popupInstance.value = popupRef.value.instance;
});

const popupVisible = ref(false);

const changePopupVisibility = value => {
    popupVisible.value = value;
    if (!value) emit('popupHidden');
};

defineExpose({
    changePopupVisibility,
    popupInstance,
});
</script>

<style lang="scss" scoped>
.class-name {
    :deep(.dx-texteditor-input) {
        color: black !important;
    }
}

.class-name {
    :deep(.dx-texteditor-container) {
        background-color: #f5f5f5;
    }
}

.ai-dx-invalid::after {
    cursor: pointer;
    position: absolute;
    top: 50%;
    right: 40%;
    margin-top: -11px;
    text-align: center;
    line-height: 23px;
    font-size: 14px;
    font-weight: 500;
    background-color: #ffffff00;
    color: #fff;
    content: '!';
    border-radius: 50%;
}

.ai-dx-invalid {
    cursor: pointer;
    position: absolute;
    top: 65%;
    right: 60px;
    margin-top: -11px;
    width: 22px;
    height: 22px;
    text-align: center;
    line-height: 23px;
    font-size: 14px;
    font-weight: 500;
    background-color: #f44336;
    color: #fff;
    content: '!';
    border-radius: 50%;
}
</style>
